import { jwtDecode } from 'jwt-decode';

const REFRESH_TOKEN_KEY = 'refreshToken';
const ACCESS_TOKEN_KEY = 'accessToken';
const ID_TOKEN_KEY = 'idToken';

class TokenService {
  getRefreshToken() {
    return localStorage.getItem(REFRESH_TOKEN_KEY);
  }
  
  setRefreshToken(token) {
    localStorage.setItem(REFRESH_TOKEN_KEY, token);
  }
  
  getAccessToken() {
    return localStorage.getItem(ACCESS_TOKEN_KEY);
  }
  
  setAccessToken(token) {
    localStorage.setItem(ACCESS_TOKEN_KEY, token);
  }
  
  getIdToken() {
    return localStorage.getItem(ID_TOKEN_KEY);
  }
  
  setIdToken(token) {
    localStorage.setItem(ID_TOKEN_KEY, token);
  }
  
  clearTokens() {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
    localStorage.removeItem(ID_TOKEN_KEY);
  }

  isTokenExpired(token) {
    if (!token) return true;
    try {
      const decoded = jwtDecode(token);
      return decoded.exp * 1000 < Date.now();
    } catch {
      return true;
    }
  }

  getAccessTokenInfo() {
    const token = this.getAccessToken();
    if (!token) return null;
    try {
      return jwtDecode(token);
    } catch {
      return null;
    }
  }

  getIdTokenInfo() {
    const token = this.getIdToken();
    if (!token) return null;
    try {
      return jwtDecode(token);
    } catch {
      return null;
    }
  }
}

export default new TokenService();